import React, { useState, useRef, useEffect, useCallback } from "react";
import { Line } from "react-chartjs-2";
import styled from "styled-components/macro";
import { Chart, registerables, ChartType, ChartConfiguration, ChartTypeRegistry } from "chart.js";
import 'chartjs-adapter-date-fns';
import { enUS, de } from 'date-fns/locale'; // 차트에 사용할 로케일
import { useSelector } from "react-redux";
import { RootState } from "../reducer/index";
import dayjs from "dayjs";
import "dayjs/locale/ko";
import { GetWeather, GetWeathertemp, Getenvirdata4 } from "../reduxaction/post";
import { useAppDispatch } from "../store";
import moment from 'moment';
import { gridColumnLookupSelector } from "@mui/x-data-grid";

dayjs.locale("ko");

Chart.register(...registerables);

const ChartCon = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding-left: 20px;
  padding-right: 20px;
  margin-top: 20px;
`;

const SerachButton = styled.div`
  background-color: pink;
  margin: 10px;
  width: 50px;
  height: 30px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

type TTargetSnsr = "temp" | "hum" | "gndTemp";

interface Props {
	elseTags: any;
	startDate: string;
	endDate: string;
	stdTime: string;
	type: string;
}

//  interface Props {
//  	removeFromAllSelectTagLists: (tagIdToRemove: number) => void;
// }

const LineChart4 = ({ elseTags, startDate, endDate, stdTime, type }: Props) => {
	
	const { Farms, Targetfarms, Diarylist, Weathertemp, Weather, envirdata4 } =
		useSelector((state: RootState) => state.post);
	const [targetSnsr, setTargetSnsr] = useState({
		temp: true,
		hum: true,
		gndTemp: true,
	});
	const [renderSnsrData, setRenderSnsrData] = useState<
		Array<{ name: TTargetSnsr; value: Array<number> }>
	>([]);
	const [wrapperSize, setWrapperSize] = useState<{
		height: number;
		width: number;
	}>({ height: 300, width: 700 });

	const originSnsrData = useRef<
		Array<{ name: TTargetSnsr; value: Array<number> }>
	>([]);
	const chartWrapperRef = useRef<HTMLDivElement>(null);
	const canvasRef = useRef<HTMLCanvasElement>(null);
	const chartRef = useRef<any>(null);

	const dispatch = useAppDispatch();

	useEffect(() => {
		calcWrapper();
		if (elseTags.length !== 0) {
			fetchRequestChartData();
		}
	}, [elseTags, startDate, endDate, stdTime, type]);

	useEffect(() => {
		if (renderSnsrData.length < 1) return;
		renderChartControl();
	}, [renderSnsrData, elseTags, startDate, endDate, stdTime, type]);

	const calcWrapper = () => {
		const calcWidth = chartWrapperRef.current?.offsetWidth as number;
		const calcHeight = chartWrapperRef.current?.offsetHeight as number;

		setWrapperSize({
			width: calcWidth - 100,
			height: calcHeight,
		});
	};

	const targetSnsrControl = (target: TTargetSnsr) => {
		try {
			setTargetSnsr({ ...targetSnsr, [target]: !targetSnsr[target] });
			if (chartRef.current !== null) {
				chartRef.current.destroy();
			}
			// 빼는거
			if (targetSnsr[target]) {
				let tempData = [...renderSnsrData];
				let idx = tempData.findIndex((e) => e.name == target);
				tempData.splice(idx, 1);
				setRenderSnsrData(tempData);
			} else {
				let tempData = originSnsrData.current.find((e) => e.name == target);
				if (tempData == undefined) throw Error("no data");
				setRenderSnsrData([...renderSnsrData, tempData]);
			}
		} catch (err: any) {
			console.log(err.message);
			alert(err.message);
		}
	};

	const changeUnitForRequest = (unit: string) => {
		switch (unit) {
			case '시간':
				return 'hourly';
			case '일':
				return 'daily';
			case '주':
				return 'weekly';
			case '월':
				return 'monthly';
			default:
				return 'hourly';
		}
	};

	const changeUnitForChart = (unit: string) => {
		switch (unit) {
			case '시간':
				return 'hour';
			case '일':
				return 'day';
			case '주':
				return 'week';
			case '월':
				return 'month';
			default:
				return 'hour';
		}
	};

	const fetchRequestChartData = async () => {
		let tagIds = "";

		if (elseTags.length !== 0) {
			elseTags.forEach((e: any) => {
				tagIds += `${e.tagId},`;
			});
			tagIds = tagIds.slice(0, -1);
		};

		let data = {
			tagIds: tagIds,
			startDate: startDate,
			endDate: endDate,
			stdTime: stdTime,
			type: changeUnitForRequest(type)
		};
		
		const result = await dispatch(Getenvirdata4(data));

		console.log("result44 :: " , result.payload);
		console.log("result44 :: " , result.payload.EMPTYDATA);

		// if(result.payload.ETC == undefined && (result.payload.EMPTYDATA != 'undefined'
		// 	 || result.payload.EMPTYDATA != undefined || result.payload.EMPTYDATA != null)) {
		// 	removeFromAllSelectTagLists(Number(tagIds));
		// }

		if (chartRef.current !== null) {
			chartRef.current.destroy();
		}

		const tempdata = new Array(20)
			.fill(null)
			.map((e) => Math.floor(Math.random() * (40 - -20)) + -10);
		const humdata = new Array(10)
			.fill(null)
			.map((e) => Math.floor(Math.random() * (100 - 0)) + 0);
		const gndTemp = new Array(10)
			.fill(null)
			.map((e) => Math.floor(Math.random() * (40 - -20)) + -10);
		originSnsrData.current = [
			{ name: "temp", value: tempdata },
			{ name: "hum", value: humdata },
			{ name: "gndTemp", value: gndTemp },
		];

		setRenderSnsrData([
			{ name: "temp", value: tempdata },
			{ name: "hum", value: humdata },
			{ name: "gndTemp", value: gndTemp },
		]);
	};

	const renderChartControl = () => {

	};

	function createDatasets(envirdata: any[], elseTags: any[]) {


		console.log("여기");
		console.log(envirdata);

		const colors = [
			'rgba(255, 255, 0, 0.2)',  // 노란색 (따뜻한)
		];

		const borderColors = [
			'rgba(255, 255, 0, 1)',
		];

		// 1. envirdata를 tagId 별로 그룹화
		/* const groupedData = envirdata.reduce((groups: any, item: any) => {
			const key = item.tagId;
			if (!groups[key]) {
				groups[key] = [];
			}
			groups[key].push(item);
			return groups;
		}, {}); */

		const groupedData: { [key: number]: any[] } = {};

		for (const key in envirdata) {
			if (envirdata.hasOwnProperty(key)) {
				const items = envirdata[key];
				for (const item of items) {
					const tagId = item.tagId;
					if (!groupedData[tagId]) {
						groupedData[tagId] = [];
					}
					groupedData[tagId].push(item);
				}
			}
		}

		if (!groupedData) {
			return [];
		}

		// 2. 각 그룹에 대해 데이터셋 생성
		const datasets = Object.keys(groupedData).map((tagId: string, index: number) => {
			// 2.1. tagId에 해당하는 name 찾기
			// const name = elseTags.find((item: any) => item.tagId === Number(tagId))?.name;
			// const label = "ETC"; //elseTags[0].name;
			const tagIdNumber = Number(tagId);

			const udname = elseTags[0].name;
			const name = elseTags.find((item: any) => item.tagId === Number(tagId))?.name || udname;

			// 2.2. 데이터셋 생성
			return {
				label: name, // tagId에 해당하는 name을 레이블로 사용
				data: groupedData[tagIdNumber]?.map((item: any) => ({
					x: moment(item.time).format('YYYY-MM-DD HH:mm:ss'), // x 값은 'YYYY-MM-DD HH:mm:ss' 형식의 날짜
					y: item.value, // y 값은 value
					time: item.time, // 원본 시간을 데이터에 포함
				})),
				// backgroundColor: colors[index % colors.length],
				// borderColors: borderColors[index % borderColors.length],
				fill: false,
				lineTension: 0,
				// 다른 데이터셋 설정...
			};
		});

		return datasets;
	}

	useEffect(() => {

		if (envirdata4 === undefined) return;

		// 기존 envirdata 는 통채로 넘어옴
		// 수정된 API는 TEMP, HUMID, CO2, ETC 4가지로 나뉨 
		// 각 센서마다 차트가 표현되어야함. 2024-05-27 br

		if (canvasRef.current) {
			const ctx = canvasRef.current.getContext('2d');

			if (envirdata4.length < 1) {

				if (canvasRef.current) {

					if (ctx) {
						ctx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height); // 캔버스 지우기
						ctx.save();
						ctx.textAlign = 'center';
						ctx.textBaseline = 'middle';
						ctx.font = '16px Spoqa500'; // 글자 크기와 글꼴 설정
						ctx.fillStyle = '#666'; // 글자 색상 설정
						ctx.fillText('데이터가 없습니다.', canvasRef.current.width / 2, canvasRef.current.height / 2);
						ctx.restore();
					}
				}
				return;
			}

			// 데이터셋 생성
			const datasets = createDatasets(envirdata4, elseTags);

			const chart = new Chart(canvasRef.current, {
				type: 'line',
				data: {
					datasets: datasets, // 생성한 데이터셋 설정
				},
				options: {
					responsive: true,
					maintainAspectRatio: false,
					scales: {
						x: {
							type: 'time',
							min: moment(startDate).format('YYYY-MM-DD HH:mm:ss'),
							time: {
								unit: changeUnitForChart(type), // x축의 시간 단위 설정 (hour, day, week, month 등
								parser: 'yyyy-MM-dd HH:mm:ss',
								tooltipFormat: 'yyyy-MM-dd HH:mm:ss',
								displayFormats: {

								}
							},
							ticks: {
								padding: 10, // x축의 패딩을 10으로 설정
								callback: function (value, index, values) {
									if (type === '시간') {
										return moment(value).format('YYYY-MM-DD HH:mm:ss');
									} else if (type === '일') {
										return moment(value).format('YYYY-MM-DD');
									} else if (type === '주') {
										return moment(value).format('YYYY-MM-DD');
									} else if (type === '월') {
										return moment(value).format('YYYY-MM');
									} else {
										return moment(value).format('YYYY-MM-DD HH:mm:ss');
									}
								}
							}
						},
						// y축 설정...
					},
					// 다른 옵션...
				}
			});

			return () => {
				chart.destroy();
			};
		}
	}, [envirdata4, elseTags]);

	// const renderChartControl = () => {
	// 	try {
	// 		const transformDataForChart = (data:any) => {
	// 			const result: { [key: string]: { tagId: number, value: any[], time: any[] } } = {};
	// 			data.forEach((item: any) => {
	// 				if (!result[item.tagId]) {
	// 					result[item.tagId] = {
	// 						tagId: item.tagId,
	// 						value: [],
	// 						time: []
	// 					};
	// 				}
	// 				result[item.tagId].value.push(item.value);
	// 				// result[item.tagId].time 에 UTC 타입의 DATE 객체로 변환하여 저장한다.
	// 				// const utcDate = new Date(item.time);
	// 				// result[item.tagId].time.push(utcDate.toISOString());
	// 				// result[item.tagId].time.push(item.time);
	// 				result[item.tagId].time.push(dayjs(item.time).format('YYYY-MM-DD HH:mm:ss'));
	// 			});

	// 			// 배열로 변환하여 반환
	// 			return Object.values(result);
	// 		};
	// 		const groupByTagIdInEnvirdata = transformDataForChart(envirdata);

	// 		const labelSetForChart = (data:any) => {
	// 			const result = new Set<string>();
	// 			data.forEach((item:any) => {
	// 				item.time.forEach((time: any) => {
	// 					result.add(time);
	// 				});
	// 			});
	// 			return Array.from(result);
	// 		};

	// 		const labels = labelSetForChart(groupByTagIdInEnvirdata);

	//     // let labels = groupByTagIdInEnvirdata[0].time.map((v: any) => {
	//     //   return v;
	// 		// });

	// 		let renders = groupByTagIdInEnvirdata.map((v) => {
	//       const pick = selectTagList.filter(
	//         (item: any) => item.tagId === Number(v.tagId)
	//       );

	//       let label = pick[0].name;
	// 			console.log(pick[0])


	//       // if (pick[0].tagClass.code === "TEMP") {
	//       //   label = "온도";
	//       // } else if (pick[0].tagClass.code === "HUM") {
	//       //   label = "습도";
	//       // } else if (pick[0].tagClass.code === "CO2") {
	//       //   label = "CO2";
	//       // } else if (pick[0].tagClass.code === "NH3") {
	//       //   label = "NH3";
	//       // } else if (pick[0].tagClass.code === "TEMP") {
	//       //   label = "O2";
	//       // } else if (pick[0].tagClass.code === "LIGHT") {
	//       //   label = "조도";
	//       // } else if (pick[0].tagClass.code === "TEMP") {
	//       //   label = "HD";
	//       // }

	//       // let backgroundColor = "";
	//       // let borderColor = "";

	//       // if (label.includes("온도")) {
	//       //   backgroundColor = "#73972c";
	//       //   borderColor = "#73972c";
	//       // } else if (label.includes("습도")) {
	//       //   backgroundColor = "#377CFF";
	//       //   borderColor = "#377CFF";
	//       // } else if (label.includes("CO₂")) {
	//       //   backgroundColor = "#7C70E4";
	//       //   borderColor = "#7C70E4";
	//       // } else if (label.includes("NH")) {
	//       //   backgroundColor = "#FFAA6C";
	//       //   borderColor = "#FFAA6C";
	//       // } else if (label.includes("조도")) {
	//       //   backgroundColor = "#FFDE30";
	//       //   borderColor = "#FFDE30";
	//       // } else if (label.includes("HD")) {
	//       //   backgroundColor = "#F76CCB";
	//       //   borderColor = "#F76CCB";
	//       // }

	//       return {
	//         label: label,
	//         data: v.value,
	//         // backgroundColor,
	//         // borderColor,
	//       };
	//     });

	//     let data = {
	//       // labels,
	//       labels,
	//       datasets: renders,
	//     };

	// 		console.log("data : " , data);

	// 		const config: ChartConfiguration = {
	// 			type: 'line' as keyof ChartTypeRegistry,
	// 			data: data,
	// 			options: {
	// 				plugins: {
	// 					title: {
	// 						display: false,
	// 					}
	// 				},
	// 				scales: {
	// 					x: {

	// 						adapters: {
	// 							// date: {
	// 							// 	locale: enUS,
	// 							// 	zone: 'utc-8',
	// 							// },
	// 						},
	// 					},

	// 					y: {
	// 						title: {
	// 							text: 'Value',
	// 							display: false,
	// 						}
	// 					}
	// 				}
	// 			}
	// 		};

	// 		let ctx = canvasRef.current?.getContext("2d");

	// 		if(ctx === undefined || ctx === null) {
	// 			return;
	// 		} else {
	// 			if (chartRef.current !== null) chartRef.current.destroy();
	// 			const chartInter = new Chart(ctx, config);
	// 			chartRef.current = chartInter;
	// 		}

	//   } catch (err: any) {
	//     console.log(err.message);
	//   }
	// };

	return (
		<>
			<ChartCon ref={chartWrapperRef}>
				<canvas
					width={wrapperSize.width}
					height={wrapperSize.height}
					ref={canvasRef}
				/>
			</ChartCon>
		</>
	);
};
export default LineChart4;
